import React, { FC } from 'react';
import AuthLayout from '@layout/auth/AuthLayout';
import LoginForm from '@modules/auth/components/LoginForm';
import { Auth } from '@modules/auth/model';
import { AuthService } from '@modules/auth/service';
import Seo from '@shared/modules/seo/Seo';
import * as EI from 'fp-ts/Either';
import { defineRoute } from '@core/router';
import { defineAction, useAction } from '@core/router/action';
import { parseQueriesFormUrl } from '@shared/utils/queries';
import { getStringQuery } from '@shared/modules/filter';
import { constFalse } from 'fp-ts/function';
import { Text } from '@mantine/core';

const actions = {
  authenticate: defineAction({
    type: 'authenticate',
    payload: Auth.AuthenticateParams,
    handler: ({ payload }) => AuthService.authenticate(payload),
    flashOptions: {
      error: constFalse,
    },
    redirect: ({ request, result }) => {
      if (EI.isRight(result)) {
        return getStringQuery(parseQueriesFormUrl(request.url), 'referrer') ?? '/';
      }

      return null;
    },
  }),
};

const LoginPage: FC = () => {
  const [loading, authenticate, error] = useAction(actions.authenticate);

  return (
    <AuthLayout title="Bienvenue">
      <Seo title="S'identifier" />

      <Text size="sm" c="gray.6" mt={5} mb={24}>
        Votre espace portail professionnels.
      </Text>

      <LoginForm loading={loading} error={error} onSubmit={authenticate} />
    </AuthLayout>
  );
};

const loginRoute = defineRoute({
  component: LoginPage,
  actions,
});

export default loginRoute;
